module.exports = __webpack_public_path__ + "images/for_company_page/LP_header_e95f9d7617ddc270d913add24ea2e08a.jpg";